import SkeletonCreator from "../skeleton-creator.js";
import MultiSkeleton from "./multi-skeleton.js";

class SkeletonMultiCreator extends SkeletonCreator {
    constructor(creators) {
        super();
        this._creators = Object.assign({}, creators);
    }

    create(bindMatrixArray, bones, inverses) {
        const skeletons = {};

        for (const key in this._creators) {
            skeletons[key] = this._creators[key].create(bindMatrixArray, bones.map(bone => bone.objects[key]), inverses);
        }

        return new MultiSkeleton(skeletons);
    }

    dispose(skeleton) {
        for (const key in this._creators) {
            this._creators[key].dispose(skeleton.skeletons[key]);
        }
    }
}

export default SkeletonMultiCreator;
